export const DD_MMM_YY = 'dd MMM yy';
export const DD_MMMM_YYYY = 'dd MMMM yyyy';

export const YYYY_MM_DD = 'YYYY-MM-DD';
export const YYYY_MM_D = 'yyyyMMdd';

export const MONTHS_OF_YEAR = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];
